import { render, staticRenderFns } from "./EditDrugStore.vue?vue&type=template&id=bc58f380&scoped=true&lang=pug&"
import script from "./EditDrugStore.vue?vue&type=script&lang=ts&"
export * from "./EditDrugStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc58f380",
  null
  
)

export default component.exports